/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Parameters for update lifecycle states job.

Scans for inactive students, ghost courses, and obsolete module versions.
 */
export interface UpdateLifecycleStatesJobParams {
  dryrun?: boolean;
}
